import * as React from 'react'

import { Checkbox as CheckboxPrimitive } from 'radix-ui'

import { cn } from './cn'

export interface CheckboxProps {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (
    event: { target: { checked: boolean; name?: string } },
    checked: boolean,
  ) => void
  disabled?: boolean
  name?: string
  id?: string
  size?: 'small' | 'medium'
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
  className?: string
  inputProps?: Record<string, unknown>
  required?: boolean
  'aria-label'?: string
}

const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  (
    {
      checked,
      defaultChecked,
      onChange,
      disabled,
      name,
      id,
      size = 'medium',
      color = 'primary',
      className,
      inputProps,
      required,
      ...props
    },
    ref,
  ) => (
    <CheckboxPrimitive.Root
      ref={ref}
      id={id}
      name={name}
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={(next) => {
        const isChecked = next === true
        onChange?.({ target: { checked: isChecked, name } }, isChecked)
      }}
      disabled={disabled}
      required={required}
      className={cn(
        'group inline-flex shrink-0 cursor-pointer items-center justify-center rounded-md border transition-all duration-150',
        size === 'small' ? 'h-[18px] w-[18px]' : 'h-5 w-5',
        'border-divider-strong bg-paper shadow-paper',
        'data-[state=checked]:border-primary data-[state=checked]:bg-primary',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-paper',
        'disabled:pointer-events-none disabled:opacity-40',
        className,
      )}
      {...(inputProps as object)}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="text-primary-contrast">
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-full w-full">
          <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ),
)
Checkbox.displayName = 'Checkbox'

export default Checkbox
